import React from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'
import Checkbox from '@material-ui/core/Checkbox'
import { useTranslation } from 'react-i18next'
import Timekeeper from 'react-timekeeper'
// import 'react-times/css/material/default.css'
import { isMobile } from 'react-device-detect'
import PropTypes from 'prop-types'

import {
  GenericContainer,
  LeftGradientSection,
} from '../shared/DefaultStyledComponents'
import treningBackground from '../../assets/addUserScreen/background-trening.png'
import AboutYouPagination from './AboutYouPagination'
import VideoBox from '../shared/VideoBox'
import AddImage from './AddImage'

import notificationIcon from '../../assets/addUserScreen/step3/notification_icon.png'
import userOutlineFront from '../../assets/addUserScreen/step5/user_outline_front.png'
import userOutlineSide from '../../assets/addUserScreen/step5/user_outline_side.png'
import checkboxCheck from '../../assets/addUserScreen/newTrening/checkbox_check.png'
import checkboxBorderEven from '../../assets/addUserScreen/newTrening/checkbox_border_even.png'
import checkboxBorderOdd from '../../assets/addUserScreen/newTrening/checkbox_border_odd.png'
import clock from '../../assets/addUserScreen/newTrening/clock.png'
import agreeButtonBackground from '../../assets/addUserScreen/pickTime/buttonBackground.png'

import { fontSizeResponsive, mediaQ } from '../theme/mixins'

export const AboutLeftYouSection = styled(LeftGradientSection)`
  padding-left: 10.8vw;

  ${mediaQ('mobileAll', 'width:100%; height:5vh;padding-left:0')}
`
const AddUserContainer = styled(GenericContainer)`
  background: url('${treningBackground}');
  background-size: cover;

  ${mediaQ('mobileAll', 'flex-direction:column;')}
`
const AboutYouMainHeader = styled.div`
  position: absolute;
  top: 8.9vh;
  left: 10.8vw;
  ${fontSizeResponsive(45)};
  font-family: 'Asap Condensed';
  color: white;

  ${mediaQ('mobileAll', 'position:relative;top:unset;left:15px; width:80%;')}
`
const AboutYouCenterContent = styled.div`
  ${fontSizeResponsive(44)};
  font-family: 'Asap';
  color: white;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  max-width: calc(5.4vw + 47.2%);

  ${mediaQ(
    'mobileAll',
    'position:fixed; top: 40%; color: black;width: 200px;text-align: center;left: calc(50% - 100px);'
  )}

  &.step1 {
    ${mediaQ(
      'mobileAll',
      'position:fixed; top: 10%; color: black;width: 300px;text-align: center;left: calc(50% - 100px);'
    )}
  }
  &.step2,
  &.step3,
  &.step4 {
    ${mediaQ(
      'mobileAll',
      'position:fixed; top: 20%; color: black;width: 300px;text-align: center;left: calc(50% - 100px);'
    )}
  }
  &.step5 {
    ${mediaQ(
      'mobileAll',
      'position:fixed; top: 15%; color: black;width: 300px;text-align: center;left: 7%;'
    )}
  }
  &.step8 {
    ${mediaQ('mobileAll', 'position:fixed; top: 15%;left:10%;')}
  }
  &.step9 {
    ${mediaQ('mobileAll', 'position:fixed; top: 15%;left:25%;')}
  }
`

export const AboutRightYouSection = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${mediaQ('mobileAll', 'width:100%')}

  &.step5,&.step6,&.step7 {
    ${mediaQ('mobileS', 'justify-content:end;')};
  }
`
const AboutYouInput = styled.input`
  width: 23.6vw;
  margin-left: 14.7395839782%;
  padding: 15px 10px;
  border: none;
  border-bottom: 2px solid #9e0dfe;
  background-color: transparent;
  opacity: 0.8;
  font-family: 'Open Sans';
  ${fontSizeResponsive(24)};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.08;
  letter-spacing: normal;
  text-align: left;
  color: #212121;
  margin-bottom: 15px;

  ${mediaQ('mobileAll', 'width:80%; margin-left:7%;')}

  &.time {
    margin-left: unset;
    margin-left: 1.7vw;
  }
`

const PrivacyNotification = styled.div`
  display: flex;
  font-family: 'Open Sans';
  ${fontSizeResponsive(18)};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: left;
  color: #212121;
  left: 57.5%;
  position: absolute;
  bottom: 26.2vh;

  ${mediaQ('mobileAll', 'left: 7%; width: 86%;bottom: 20.2vh;')}

  span {
    margin-left: 1.1vw;
    max-width: 20.5vw;
    ${mediaQ('mobileAll', 'max-width: unset; align-self:center;')}

    b {
      font-weight: 700;
    }
  }

  &.step4 {
    ${mediaQ('mobileAll', 'bottom:10vh;')}
  }
`
const NotificationIcon = styled.div`
  background: url('${notificationIcon}');
  background-size: cover;
  width: 52.5px;
  height: 52.5px;
  ${mediaQ(
    'mobileAll',
    'background-size: contain; background-repeat: no-repeat;'
  )}
`
const TextListContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQ('mobileAll', 'width:86vw;')}
`
const TextList = styled.div`
  display: flex;
  align-items: center;

  span {
    &:nth-of-type(1) {
      font-family: 'Asap';
      ${fontSizeResponsive(44)};
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.5;
      letter-spacing: normal;
      text-align: left;
      color: #ffffff;

      ${mediaQ('mobileAll', 'color:#9e0dfe;')}
    }
    :nth-of-type(2) {
      font-family: 'Open Sans';
      ${fontSizeResponsive(18)};
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.56;
      letter-spacing: normal;
      text-align: left;
      color: #ffffff;
      padding-left: ${(props) => (props.last ? '12.6%' : '6.6%')};

      ${mediaQ('mobileAll', 'color:black')}
    }
  }
`
const TextListBottom = styled.div`
  font-family: 'Open Sans';
  ${fontSizeResponsive(21)};
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.48;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin-top: 50px;
  width: 90%;
  align-self: center;

  ${mediaQ('mobileAll', 'color:black')}
`
const ReadyButtonContainer = styled.div`
  display: flex;
  margin-left: 8.1vw;

  ${mediaQ(
    'mobileAll',
    'position:absolute; bottom: 11vh; width:100%; margin-left:unset;justify-content: center;'
  )}
`

const ReadyButton = styled.button`
  width: 14vw;
  height: 6vh;
  background-color: #c5ff00;
  font-family: 'Open Sans';
  ${fontSizeResponsive(21)};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 2.1px;
  border: none;
  text-transform: uppercase;

  color: #212121;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaQ('mobileAll', 'width:unset;font-weight:bolder;')}
`
const SkipButton = styled.button`
  font-family: 'Open Sans';
  ${fontSizeResponsive(21)};
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 2.1px;
  background-color: transparent;
  border: none;
  color: #212121;
  text-transform: uppercase;
  margin-left: 11%;
`
const UserPhotoContainer = styled.div`
  width: 28.8vw;
  height: 68.7vh;
  background-image: linear-gradient(to bottom, #f0dffb, #fef3db);
  align-self: center;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaQ('mobileAll', 'width:100%; height: 100%; z-index:2;')};
  ${mediaQ('mobileS', 'height:100%;')};
`
/* prettier-ignore */ const UserOutline = styled.div`
  /* background: url('${(props) =>props.image === 'front' || props.image === 'back' ? userOutlineFront : userOutlineSide}'); */
  background-repeat: no-repeat;
  background-position: center;
  width:100%;
  height: 100%;
  z-index: 2;

  ${mediaQ('mobileS', 'background-size:contain;')};
`
const PhotoSideText = styled.div`
  position: absolute;
  top: 36.1vh;
  font-family: 'Asap Condensed';
  font-size: 33px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: normal;
  color: #fe0d9f;
`
const NewTrenningContainer = styled.div``
const NewTrenningHeader = styled.div`
  max-width: unset;
  /* white-space: pre; */
  margin-bottom: 10%;
`
const NewTrenningSubHeader = styled.div`
  font-family: 'Open Sans';
  ${fontSizeResponsive(18)};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;

  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
`

export const PickTrenningDayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

/* prettier-ignore */ export const CustomUncheckedIcon = styled.div`
  background: url('${(props) => props.odd ? checkboxBorderEven : checkboxBorderOdd}');
  background-size: contain;
  width: 25px;
  height: 25px;
  background-repeat: no-repeat;

  ${mediaQ('mobileAll', 'width:20px; height: 20px;')}

`

/* prettier-ignore */ export const CustomCheckedIcon = styled.div`
  width: 25px;
  height:25px;
  background: ${(props) => props.odd ? '#1eee81' : '#fe0d9f'} url("${checkboxCheck}");
  background-repeat: no-repeat;
  background-size: 18px;
  background-position: center;

  ${mediaQ('mobileAll', 'width:20px; height: 20px;')}
`
export const TrenningTimeContainer = styled.div`
  display: flex;
  margin-left: 14.7395839782%;
  align-items: center;

  ${mediaQ('mobileAll', 'margin-left:7%;')};
`
export const ClockIcon = styled.div`
  width: 60px;
  height: 60px;
  background: url('${clock}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-top: 10px;
`

export const CheckboxContainer = styled.div`
  display: flex;
  align-self: baseline;
  align-items: center;
  width: ${(props) => (props.trainingReminder ? 'unset' : '100%')};
  left: ${(props) => (props.trainingReminder ? '58.1vw' : 'unset')};
  top: ${(props) => (props.trainingReminder ? '87.2vh' : 'unset')};
  position: ${(props) => (props.trainingReminder ? 'absolute' : 'unset')};
  justify-content: center;
  justify-content: ${(props) => (props.bottom ? 'center' : 'unset')};
  font-family: 'Asap Condensed';
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : 'unset')};
  font-weight: ${(props) => (props.fw ? props.fw : 'unset')};
  font-size: ${(props) => (props.fs ? fontSizeResponsive(props.fs) : 'unset')};

  /* ${fontSizeResponsive((props) => (props.fs ? props.fs : 22))} */

  &.trainingReminder {
    ${mediaQ('mobileAll', 'left:7%; top: 80.2vh;')};
  }

  label {
    font-family: 'Asap Condensed';
    ${fontSizeResponsive(25)};
    font-weight: 500;
    font-style: normal;
    letter-spacing: normal;
    text-align: right;
    color: #212121;
    width: 50%;

    &.trainingReminder {
      text-align: left;
      width: 100%;
      font-family: 'Open Sans';
      ${fontSizeResponsive(18)};
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #212121;
      margin-left: 15px;
    }
  }
`
const NumberCheckedCheckboxText = styled.div`
  position: absolute;
  left: 66.3vw;
  bottom: 10.6vh;
  color: #212121;
  font-family: 'Open Sans';
  ${fontSizeResponsive(18)};
  font-weight: 600;

  span {
    color: #9e0dfe;
    font-family: 'Open Sans';
    ${fontSizeResponsive(18)};
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    font-weight: bold;
  }
`
const TrainingAgreeButton = styled.div`
  background: url(${agreeButtonBackground});
  background-size: cover;
  background-repeat: no-repeat;
  width: 14vw;
  height: 6.2vh;
  margin-left: 14.7395839782%;
  margin-top: 10.6vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Open Sans';
  ${fontSizeResponsive(21)};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 2.1px;
  color: #ffffff;
  cursor: pointer;

  ${mediaQ('mobileAll', 'position: absolute;top: 39%;right: 7%;')};
  ${mediaQ('mobileS', 'top: 45%')};
`
const CustomReminderCheckboxChecked = styled.div`
  background-image: url('${checkboxCheck}');
  background-color: rgb(250, 173, 2);
  background-repeat: no-repeat;
  background-size: 18px;
  background-position: center;
  width: 40px;
  height: 40px;
  border: 1px solid transparent;
`
const CustomReminderCheckboxUnChecked = styled.div`
  width: 40px;
  height: 40px;
  border: 1px solid rgb(250, 173, 2);
`

export const TimeInput = styled.div`
  width: 23vw;
  height: 50px;
  border-bottom: 1px solid #9e0dfe;
  margin-left: 30px;
  padding: 5px 10px;
  display: flex;
  align-items: center;

  ${mediaQ('mobileAll', 'width:35vw;')};

  .timepicker-container {
    width: 100%;
    height: 100%;

    input {
      border: none;
      width: 100%;
      height: 100%;
      background-color: transparent;
      opacity: 0.5;
      font-family: 'Open Sans';
      ${fontSizeResponsive(24)};
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.08;
      letter-spacing: normal;
      color: #212121;
    }
  }

  span {
    opacity: 0.5;
    font-family: 'Open Sans';
    ${fontSizeResponsive(24)};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.08;
    letter-spacing: normal;
    color: #212121;
  }
`

export const TimeModal = styled(Modal)`
  width: ${(props) => (props.newPlanNotificationModal ? 'unset' : '350px')};
  height: ${(props) => (props.newPlanNotificationModal ? 'unset' : '350px')};
  min-height: ${(props) =>
    props.newPlanNotificationModal ? 'unset' : '500px'};
  border: 1px solid black;
  position: absolute;
  top: ${(props) =>
    props.newPlanNotificationModal ? 'calc(50% -  33px);' : '22.5vh'};
  left: ${(props) =>
    props.newPlanNotificationModal
      ? 'calc(50% - 222px);'
      : 'calc(50% - 175px)'};
  background-color: white;

  .react-timekeeper {
    width: 100%;
    height: 100%;

    &__tb-colon {
      opacity: 0.6;
      font-family: 'Asap Condensed';
      ${fontSizeResponsive(71)};
      font-weight: bold;
      font-stretch: condensed;
      font-style: normal;
      letter-spacing: normal;
      color: #ffffff;
    }
    &__clock {
      transform: scale(1.5);
      margin-top: 22%;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
      background-color: #e8e8e8;
    }
    &__top-bar {
      height: 15%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #1eee81;

      button {
        background: transparent;
        font-family: 'Asap Condensed';
        ${fontSizeResponsive(19)};
        font-weight: normal;
        font-stretch: condensed;
        font-style: normal;
        line-height: 1.58;
        letter-spacing: normal;
        text-align: left;
        color: #ffffff;
      }
    }
    &__tb-minute-wrapper,
    &__tb-hour-wrapper {
      span {
        opacity: 0.6;
        font-family: 'Asap Condensed';
        ${fontSizeResponsive(71)};
        font-weight: bold;
        font-stretch: condensed;
        font-style: normal;
        letter-spacing: normal;
        color: #ffffff;
        &.react-timekeeper__tb-hour--active,
        &.react-timekeeper__tb-minute--active {
          opacity: 1;
        }
      }
    }
    &__hand-circle-outer,
    &__clock-hand,
    &__hand-intermediate-circle {
      fill: white;
      stroke: white;
    }

    &__clock-wrapper {
      height: 80%;
      padding: 0;
      background-color: white;

      div {
        &:nth-of-type(2) {
          position: absolute;
          top: 6%;
          right: 0;
          display: flex;
          flex-direction: column;

          button {
            background: transparent;
            font-family: 'Asap Condensed';
            ${fontSizeResponsive(19)};
            font-weight: normal;
            font-stretch: condensed;
            font-style: normal;
            line-height: 1.58;
            letter-spacing: normal;
            text-align: left;
            color: #ffffff;
          }
        }
      }
    }
    &__done-button {
      height: 10%;
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }

  ${mediaQ('mobileAll', 'width:100vw;height:70%;top:4%;left:unset;')};
  ${mediaQ('mobileS', 'width:100vw;height:70%;top:-3%;left:unset;')};
`
export const ModalButtonsContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: row-reverse;

  ${mediaQ('mobileS', 'bottom: 0%;')};

  button {
    font-family: 'Open Sans';
    ${fontSizeResponsive(16)};
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: 0.8px;
    text-align: right;
    color: #fe0d9f;
    border: none;
    background-color: transparent;
    padding: 20px 20px;
    text-transform: uppercase;

    ${mediaQ('mobileAll', 'width:50%;text-align: center;font-size:18px;')};

    &:nth-of-type(2) {
      color: #212121;
    }
  }
`

const NewTreningPlanNotification = styled.div`
  /* width: 357px; */
  height: 27px;
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(24)};
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  /* line-height: 4.71; */
  letter-spacing: 2.4px;
  /* text-align: left; */
  color: #212121;
  width: 444px;
  height: 67px;
  background-color: #c5ff00;
  display: flex;
  justify-content: center;
  align-items: center;
`

const AddUser = ({
  steps,
  activeStep,
  userName,
  onInputEdit,
  onNavButtonClick,
  bellyCircumference,
  hipCircumference,
  thighCircumference,
  trenningTime,
  checkTrenningDay,
  nbCheckedCheckboxes,
  trainingDays,
  goToStep,
  onImageSave,
  changeDefaultBackground,
  userFrontPhoto,
  userBackPhoto,
  userSidePhoto,
  resetBackground,
  checkReminder,
  storeData,
  setTempTime,
  saveTempTime,
  isModalOpen,
  openModal,
  closeModal,
  isNotificationModalOpen,
  secondVideo,
  onChangeHandler,
  userBackBackground,
  userSideBackground,
  userFrontBackground,
  isAgreementButtonsOn,
  saveOriginalImages,
  defaultTrenningTime,
}) => {
  const { t } = useTranslation('addUser')

  const stepTexts = [
    t('arrays.stepTexts.line1'),
    t('arrays.stepTexts.line2'),
    t('arrays.stepTexts.line3'),
    t('arrays.stepTexts.line4'),
    t('arrays.stepTexts.line5'),
    t('arrays.stepTexts.line6'),
    t('arrays.stepTexts.line7'),
    t('arrays.stepTexts.line8'),
    t('arrays.stepTexts.line9'),
  ]
  const stepInputPlaceholders = [
    t('arrays.stepInputPlaceholders.line1'),
    t('arrays.stepInputPlaceholders.line2'),
    t('arrays.stepInputPlaceholders.line3'),
    t('arrays.stepInputPlaceholders.line4'),
    t('arrays.stepInputPlaceholders.line5'),
    t('arrays.stepInputPlaceholders.line6'),
    t('arrays.stepInputPlaceholders.line7'),
    t('arrays.stepInputPlaceholders.line8'),
    '',
    t('arrays.stepInputPlaceholders.line9'),
  ]

  const PhotoSideTexts = [
    t('arrays.photoSideText.line1'),
    t('arrays.photoSideText.line2'),
    t('arrays.photoSideText.line3'),
  ]

  const weekendDays = [
    t('arrays.weekDays.line1'),
    t('arrays.weekDays.line2'),
    t('arrays.weekDays.line3'),
    t('arrays.weekDays.line4'),
    t('arrays.weekDays.line5'),
    t('arrays.weekDays.line6'),
    t('arrays.weekDays.line7'),
  ]
  const stepInputValue = [
    userName,
    '',
    bellyCircumference,
    hipCircumference,
    thighCircumference,
    '',
    '',
    '',
    '',
    trenningTime,
  ]

  const switchInputOnStep = (e, step) => {
    switch (step) {
      case 0:
        onInputEdit(e, 'name')
        break
      case 2:
        onInputEdit(e, 'bellyCircumference')
        break
      case 3:
        onInputEdit(e, 'hipCircumference')
        break
      case 4:
        onInputEdit(e, 'thighCircumference')
        break
      case 9:
        onInputEdit(e, 'trenningTime')
        break
      default:
        break
    }
  }

  const playVideo = (e) => {
    const myVideo = e.target
    if (myVideo.paused) myVideo.play()
    else myVideo.pause()
  }

  return (
    <AddUserContainer width="100vw" height="100vh" maxHeight="">
      <AboutLeftYouSection>
        <AboutYouMainHeader>
          {activeStep < 8 ? t('step1.header.title') : t('step8.header.title')}
        </AboutYouMainHeader>

        <AboutYouCenterContent className={`step${activeStep}`}>
          {stepTexts[activeStep]}
          {activeStep === 9 && (
            <NewTrenningContainer>
              <NewTrenningHeader>
                {t('step8.leftSide.content.header')}
              </NewTrenningHeader>
              <NewTrenningSubHeader>
                {t('step8.leftSide.content.subHeader')}
              </NewTrenningSubHeader>
            </NewTrenningContainer>
          )}
          {activeStep === 10 && (
            <NewTrenningContainer>
              <NewTrenningHeader>
                {t('step9.leftSide.content.header')}
              </NewTrenningHeader>
            </NewTrenningContainer>
          )}
          {activeStep >= 5 && (!isMobile ? activeStep < 9 : activeStep < 6) && (
            <TextListContainer>
              <TextList>
                <span>{t('step4.leftSide.content.list.firstRow.number')}</span>
                <span>{t('step4.leftSide.content.list.firstRow.text')}</span>
              </TextList>
              <TextList>
                <span>{t('step4.leftSide.content.list.secondRow.number')}</span>
                <span>{t('step4.leftSide.content.list.secondRow.text')}</span>
              </TextList>
              <TextList>
                <span>{t('step4.leftSide.content.list.thirdRow.number')}</span>
                <span>{t('step4.leftSide.content.list.thirdRow.text')}</span>
              </TextList>
              <TextList last>
                <span> </span>
                <span>{t('step4.leftSide.content.list.fourthRow.text')}</span>
              </TextList>
              <TextListBottom>
                {t('step4.leftSide.content.bottomtext')}
              </TextListBottom>
            </TextListContainer>
          )}
        </AboutYouCenterContent>
      </AboutLeftYouSection>

      <AboutRightYouSection className={`step${activeStep}`}>
        {activeStep === 0 && (
          <AboutYouInput
            value={stepInputValue[activeStep] || null}
            placeholder={stepInputPlaceholders[activeStep]}
            onChange={(e) => switchInputOnStep(e, activeStep)}
          />
        )}
        {activeStep === 2 && (
          <AboutYouInput
            type="number"
            min="0"
            className="measure"
            value={stepInputValue[activeStep] || null}
            placeholder={stepInputPlaceholders[activeStep]}
            onChange={(e) => switchInputOnStep(e, activeStep)}
          />
        )}
        {activeStep === 3 && (
          <AboutYouInput
            type="number"
            className="measure"
            min="0"
            value={stepInputValue[activeStep] || null}
            placeholder={stepInputPlaceholders[activeStep]}
            onChange={(e) => switchInputOnStep(e, activeStep)}
          />
        )}
        {activeStep === 4 && (
          <AboutYouInput
            type="number"
            className="measure"
            min="0"
            value={stepInputValue[activeStep] || null}
            placeholder={stepInputPlaceholders[activeStep]}
            onChange={(e) => switchInputOnStep(e, activeStep)}
          />
        )}
        {activeStep === 10 && (
          <TrenningTimeContainer className="time-container">
            <ClockIcon />
            <TimeInput onClick={() => openModal('time')}>
              <span>
                {trenningTime === null ? 'Wybierz godzinę' : trenningTime}
              </span>
            </TimeInput>
            <TimeModal
              isOpen={isModalOpen}
              ariaHideApp={false}
              style={{
                content: { top: '5%' },
                overlay: { backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 33333 },
              }}
            >
              <Timekeeper
                className="clock-component"
                onChange={(data) => setTempTime(data.formatted24)}
                hour24Mode={false}
                time={
                  trenningTime !== null ? trenningTime : defaultTrenningTime
                }
              />
              <ModalButtonsContainer>
                <button type="button" ok onClick={saveTempTime}>
                  OK
                </button>
                <button type="button" onClick={() => closeModal('time')}>
                  Cancel
                </button>
              </ModalButtonsContainer>
            </TimeModal>
          </TrenningTimeContainer>
        )}

        {activeStep === 1 && (
          <VideoBox
            source={secondVideo && secondVideo.files[4].link}
            boxSize="small"
            autoplay
            onclick={(e) => playVideo(e)}
          />
        )}
        {(activeStep === 2 || activeStep === 3 || activeStep === 4) && (
          <PrivacyNotification className={`step${activeStep}`}>
            <NotificationIcon />
            <span>
              {t('step2.rightSide.privacyNotification.normal1')}
              <b>{t('step2.rightSide.privacyNotification.bold')}</b>
              {t('step2.rightSide.privacyNotification.normal2')}
            </span>
          </PrivacyNotification>
        )}
        {activeStep === 5 && (
          <ReadyButtonContainer>
            <ReadyButton onClick={() => goToStep(6)}>
              {t('step4.rightSide.readyButtonContainer.readyButton')}
            </ReadyButton>
            <SkipButton onClick={() => goToStep(9)}>
              {t('step4.rightSide.readyButtonContainer.skipButton')}
            </SkipButton>
          </ReadyButtonContainer>
        )}
        {(activeStep === 6 || activeStep === 7 || activeStep === 8) && (
          <UserPhotoContainer>
            <UserOutline
              image={
                activeStep === 6
                  ? 'front'
                  : activeStep === 7
                  ? 'side'
                  : activeStep === 8
                  ? 'back'
                  : null
              }
            >
              {activeStep === 6 && (
                <AddImage
                  changeDefaultBackground={changeDefaultBackground}
                  absolutePosition
                  onImageSave={onImageSave}
                  side="front"
                  imageUrl={userFrontPhoto}
                  resetBackground={resetBackground}
                  onChangeHandler={onChangeHandler}
                  background={userFrontBackground}
                  isAgreementButtonsOn={isAgreementButtonsOn}
                  saveOriginalImages={saveOriginalImages}
                  isEditable={true}
                />
              )}
              {activeStep === 7 && (
                <AddImage
                  changeDefaultBackground={changeDefaultBackground}
                  onImageSave={onImageSave}
                  side="side"
                  absolutePosition
                  imageUrl={userSidePhoto}
                  resetBackground={resetBackground}
                  onChangeHandler={onChangeHandler}
                  background={userSideBackground}
                  isAgreementButtonsOn={isAgreementButtonsOn}
                  saveOriginalImages={saveOriginalImages}
                  isEditable={true}
                />
              )}
              {activeStep === 8 && (
                <AddImage
                  changeDefaultBackground={changeDefaultBackground}
                  onImageSave={onImageSave}
                  absolutePosition
                  side="back"
                  imageUrl={userBackPhoto}
                  resetBackground={resetBackground}
                  onChangeHandler={onChangeHandler}
                  background={userBackBackground}
                  isAgreementButtonsOn={isAgreementButtonsOn}
                  saveOriginalImages={saveOriginalImages}
                  isEditable={true}
                />
              )}
            </UserOutline>
            <PhotoSideText>{PhotoSideTexts[activeStep - 6]}</PhotoSideText>
          </UserPhotoContainer>
        )}
        {activeStep === 9 && (
          <PickTrenningDayContainer>
            {weekendDays.map((day, i) => (
              <CheckboxContainer>
                <label>{day}</label>
                <Checkbox
                  icon={<CustomUncheckedIcon odd={i % 2 === 0 || i === 0} />}
                  checkedIcon={
                    <CustomCheckedIcon odd={i % 2 === 0 || i === 0} />
                  }
                  onChange={(e) => checkTrenningDay(e, i + 1)}
                  value={i + 1}
                  disabled={
                    !trainingDays.includes(i + 1) && nbCheckedCheckboxes >= 5
                  }
                />
              </CheckboxContainer>
            ))}
          </PickTrenningDayContainer>
        )}
        {activeStep === 10 && (
          <TrainingAgreeButton onClick={storeData}> OK </TrainingAgreeButton>
        )}
        {activeStep === 10 && (
          <CheckboxContainer
            trainingReminder
            className={activeStep === 10 ? 'trainingReminder' : ''}
          >
            <Checkbox
              icon={<CustomReminderCheckboxUnChecked />}
              checkedIcon={<CustomReminderCheckboxChecked />}
              onChange={(e) => checkReminder(e)}
            />
            <label className="trainingReminder">
              Przypominaj mi o treningu
            </label>
          </CheckboxContainer>
        )}
      </AboutRightYouSection>
      {activeStep === 9 && (
        <NumberCheckedCheckboxText>
          Zaznaczono <span>{nbCheckedCheckboxes} z 5 </span>
        </NumberCheckedCheckboxText>
      )}
      <TimeModal
        isOpen={isNotificationModalOpen}
        ariaHideApp={false}
        style={{ overlay: { backgroundColor: 'rgba(0,0,0,0.5)' } }}
        newPlanNotificationModal
      >
        <NewTreningPlanNotification>
          Ustawiłeś nowy plan treningowy
        </NewTreningPlanNotification>
      </TimeModal>
      <AboutYouPagination
        steps={steps}
        activeStep={activeStep}
        onNavButtonClick={onNavButtonClick}
      />
    </AddUserContainer>
  )
}

AddUser.propTypes = {
  steps: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  userName: PropTypes.string.isRequired,
  onInputEdit: PropTypes.func.isRequired,
  onNavButtonClick: PropTypes.func.isRequired,
  bellyCircumference: PropTypes.number.isRequired,
  hipCircumference: PropTypes.number.isRequired,
  trenningTime: PropTypes.string.isRequired,
  checkTrenningDay: PropTypes.func.isRequired,
  nbCheckedCheckboxes: PropTypes.number.isRequired,
  trainingDays: PropTypes.objectOf(PropTypes.any).isRequired,
  goToStep: PropTypes.func.isRequired,
  onImageSave: PropTypes.func.isRequired,
  changeDefaultBackground: PropTypes.func.isRequired,
  userFrontPhoto: PropTypes.objectOf(PropTypes.any).isRequired,
  userBackPhoto: PropTypes.objectOf(PropTypes.any).isRequired,
  userSidePhoto: PropTypes.objectOf(PropTypes.any).isRequired,
  resetBackground: PropTypes.func.isRequired,
  checkReminder: PropTypes.func.isRequired,
  storeData: PropTypes.func.isRequired,
  setTempTime: PropTypes.func.isRequired,
  saveTempTime: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  isNotificationModalOpen: PropTypes.bool.isRequired,
}

export default AddUser
